export default function unique(arr: string[]) {
    return arr.filter((x, i, self) => self.indexOf(x) === i);
}
